// removed by extract-text-webpack-plugin
module.exports = {"stage":"styles-stage--3aQIo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StageGhosting/styles.scss
// module id = /g6B
// module chunks = 3